<template>
  <div>
    <div class="footer" style="padding: 0 20px;">
      <p style="margin: 16px 0;" class="">
        友情链接：
        <a href="http://www.zhenyuanma.com/" target="_blank">真源码</a>
        <a href="http://www.cnhnkj.com/" target="_blank">惠农网</a>
      </p>
      <p style="padding-bottom: 16px;line-height:1.4;">
        版权所有 2013-2018 All Rights Reserved Powered by cnhnb.
        湖南惠农科技有限公司 &nbsp;
        <a style="color: #333" href="http://www.beian.miit.gov.cn">湘ICP备13007354号-2</a>
      </p>
    </div>
    <!-- <div class="footer pc pcfooter">
      <p style="margin: 20px 0;" class="">
        友情链接：
        <a href="http://cloud.zym.so/#/" target="_blank">真源码</a>
        <a href="http://www.cnhnkj.com/" target="_blank">惠农网</a>
      </p>
      <p style="padding-bottom: 20px;" >
        版权所有 2013-2018 All Rights Reserved Powered by cnhnb. 湖南惠农科技有限公司&nbsp;
        91430100062218750C
        <a style="color: #333" href="http://www.beian.miit.gov.cn">湘ICP备13007354号-2</a>
      </p>
    </div> -->
    <div style="display: none;">
      <a href="https://s4.cnzz.com/z_stat.php?id=1277914813&web_id=1277914813" target="_blank" title="站长统计">站长统计</a>
    </div>
  </div>
</template>

<script>
  export default {

  }
</script>

<style lang="scss" scoped>
.footer {
  background: #fff;
  display: block;
  // margin-top: 40px;
  text-align: center;
  border-top: 8px solid #45b035;
}
.footer p {
  font-size: 14px;
}
.footer p > a {
  color:#45b035;
}

@media screen and (min-width: 1000px) {

}
</style>



// WEBPACK FOOTER //
// src/views/footer.vue